export class WebhookV1StandardPayloadJobMetricsReportFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobMetricsReportFailed",
            "baseName": "jobMetricsReportFailed",
            "type": "WebhookV1JobMetricsReportFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadJobMetricsReportFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
